export const ExpireEventAfter7Hours = 7;
